import { Component, OnInit, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReservationmodalComponent } from '../reservationmodal/reservationmodal.component';
import { ReservationService } from '../../../core/services/reservation/reservation.service';
import { TablePersistenceService } from 'src/app/core/services/table/table-persistence.service';




@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css']
})
export class ReservationComponent implements OnInit {
  @Output() selectedreservation = new EventEmitter<any>();

  voyageid: any;

  allColumns = [
    { id: "ticket", name: "Ticket" },
    { id: "passager", name: "Nom Client" },
    { id: "phone", name: "Téléphone" },
    { id: "bus", name: "Bus" },
    { id: "tarif", name: "Tarif" },
    { id: "siege", name: "Siège" },
    { id: "destination", name: "Destination" },
    { id: "category", name: "Catégorie" },
    { id: "date", name: "Date" }
  ];

  displayedColumns = [
    "id",
    "ticket",
    "passager",
    "phone",
    "bus",
    "tarif",
    "siege",
    "destination",
    "category",
    "date",
    "action",
  ];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  lastprintstate: boolean | undefined;
  agence: any;
  base64: any;
  ispopup: any;
  reservationlist: any;

  searchCriteria = {
    nomclient: '',
    contact: '',
    place: '',
    voyageNumero: '',
    showAdvanced: localStorage.getItem('reservation_adv_filter') === 'true'
  };

  toggleAdvancedSearch(): void {
    this.searchCriteria.showAdvanced = !this.searchCriteria.showAdvanced;
    localStorage.setItem('reservation_adv_filter', String(this.searchCriteria.showAdvanced));
  }

  page = 0;
  size = 10;

  constructor(
    private dialog: MatDialog,
    private voyageservice: VoyageService,
    private activatedRoute: ActivatedRoute,private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef, private datepipe: DatePipe,
    private router: Router, private reservationService: ReservationService,
    private tablePersistenceService: TablePersistenceService
  ) {
    this.voyageid = this.activatedRoute.snapshot.params["id"];
    this.sort = new MatSort();
    this.agence = localStorage.getItem('agenceinso');
    this.agence = this.agence != null ? JSON.parse(this.agence) : null;
  }

  ngOnInit(): void {
    const savedCriteria = this.tablePersistenceService.getCriteria('reservation_search');
    if (savedCriteria) {
      this.searchCriteria = savedCriteria;
    }
    this.getreservationlist();
  }

  getreservationdata(data: any): any{
    this.selectedreservation.emit(data);
  }

  onCriteriaChange() {
    this.tablePersistenceService.saveCriteria('reservation_search', this.searchCriteria);
    this.page = 0;
    this.getreservationlist();
  }

  resetCriteria() {
    this.searchCriteria = {
      nomclient: '',
      contact: '',
      place: '',
      voyageNumero: '',
      showAdvanced: this.searchCriteria.showAdvanced
    };
    this.tablePersistenceService.clearCriteria('reservation_search');
    this.page = 0;
    this.getreservationlist();
  }

  getreservationlist(): any {
    const page = this.page != null && this.page !== undefined ? this.page : 0;
    const size = this.size != null && this.size !== undefined ? this.size : 10;
    
    const criteriaObj: any = {};
    if (this.searchCriteria.nomclient) criteriaObj.nomclient = this.searchCriteria.nomclient;
    if (this.searchCriteria.contact) criteriaObj.contact = this.searchCriteria.contact;
    if (this.searchCriteria.place) criteriaObj.place = this.searchCriteria.place;
    if (this.searchCriteria.voyageNumero) criteriaObj.voyageid = this.searchCriteria.voyageNumero;

    this.reservationService
      .getCriteriaSearch(criteriaObj, page, size, 'creationdate', 'desc')
      .subscribe((response: any) => {
        this.reservationlist = response;
        this.dataSource = new MatTableDataSource(this.reservationlist.content);
        this.changeDetectorRef.detectChanges();
      });
  }

  nextPage(event: PageEvent): any {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.getreservationlist();
  }



  delete(data: any) {}

  addReservation(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ReservationmodalComponent, {
      width: '650px', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });

    dialogref.afterClosed().subscribe((result: any) => {
      this.ispopup = false;
      // this.addReservation();
    });
  }

  editreservation(data: any): any {}
}
